module.exports = __webpack_public_path__ + "static/media/Get_your_paws_on_it.2afe4f8e.png";